<template>
  <v-container fluid align-start ma-0 pa-2 class="container-height overflow-y-hidden">
    <v-row no-gutters>
      <v-col cols="12">
        <i-card-vertical :headerTitle="menuTitle">
          <template v-slot:body>
            <v-row no-gutters>
              <v-col cols="12" class="pa-0">
                <v-row no-gutters>
                  <v-col class="pb-1">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="useBtnList"
                      :unUseBtnList="unUseBtnList"
                      :btnKey="useBtnListKey"
                      :customBtnList="customBtnList"
                      :class="[setBtnColor]"
                      @btnSave="btnSave()" @btnPrint="btnPrint()" @btnDelete="btnDelete()"
                      @btnSaveAsExcel="btnSaveAsExcel()"
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2 pb-0">
                          <i-label :label="'Request No :'" />
                          <v-col cols="2">
                            <v-autocomplete
                              :disabled="alreadyCF"
                              v-model="resNo"
                              :items="resNoList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>
                          
                            <v-checkbox
                                v-model="alreadyCF"
                                label= "Already Confirmed"
                                class="pl-5"
                                @change="checkAlreadyCF"
                            ></v-checkbox>
                            <v-col cols="1">
                            <v-autocomplete class="pl-3"
                             :disabled="!alreadyCF"
                              v-model="resNoCF"
                              :items="resNoListCF"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="btnRetrieve()"
                            />
                          </v-col>
                          <i-label :label="'Period:'" class="pl-2" />
                          <v-col cols="2">
                            <DxDateBox
                              :disabled="!alreadyCF"
                              :value="stDte"
                              height="32px"
                              display-format="yyyy-MM-dd"
                              :acceptCustomValue="false"
                              @value-changed="e => {stDte = e.value && getStrFormat(e.value)}"
                            />
                          </v-col>
                          <span class="px-2 d-flex align-center text-h6"> ~ </span>
                          <v-col cols="2">
                            <DxDateBox
                              :disabled="!alreadyCF"
                              :value="edDte"
                              height="32px"
                              display-format="yyyy-MM-dd"
                              :acceptCustomValue="false"
                              @value-changed="e => {edDte = e.value && getStrFormat(e.value)}"
                            />
                          </v-col>
                          <v-checkbox
                                v-model="prtDetail"
                                label= "Print Detail"
                                class="pl-5"
                            ></v-checkbox>
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="2" class="top">
                    <v-row no-gutters>
                      <v-col cols="5" align="right" class="pt-2 pb-2"><span class="pa-2 search">Out Date: </span></v-col>
                      <v-col cols="5" class="pt-1">
                        <DxDateBox
                          :value="plnCarryOutDte"
                          height="30px"
                          display-format="yyyy-MM-dd"
                          :acceptCustomValue="false"
                          @value-changed="e => {plnCarryOutDte = e.value}"
                        />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4" class="top">
                    <v-row no-gutters>
                      <v-col cols="4" align="right" class="pt-2 pb-2"><span class="pa-2 search">Mov Loc. : </span></v-col>
                      <v-col cols="6" class="pt-1">
                        <v-autocomplete
                          v-model="movLoc"
                          :items="movLocList"
                          return-object
                          item-value="code"
                          item-text="codeName"
                          single-line
                          outlined
                          dense
                          height="32"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="2" class="top">
                    <v-row no-gutters>
                      <v-col cols="4" align="right" class="pt-2 pb-2"><span class="pa-2 search">Car No : </span></v-col>
                      <v-col cols="6" class="pt-1">
                        <v-autocomplete
                          v-model="carNo"
                          :items="carNoList"
                          return-object
                          item-value="code"
                          item-text="codeName"
                          single-line
                          outlined
                          dense
                          height="32"/>
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="4" class="top">
                    <v-row no-gutters>
                      <v-col cols="4" align="right" class="pt-2 pb-2"><span class="pa-2 search">Driver/Receiver: </span></v-col>
                      <v-col cols="5" class="pt-1">
                        <v-select
                          v-model="perNo"
                          :items="perNoList"
                          return-object
                          item-value="code"
                          item-text="codeName"
                          single-line
                          outlined
                          dense
                          height="32"/>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
                <v-row no-gutters>
                  <v-col cols="2">
                    <v-row no-gutters><v-col cols="12" align="center" class="search top2">Contact Tel :</v-col></v-row>
                      <v-row no-gutters>
                        <v-col cols="12" align="center" class="search top2 pa-1">
                          <v-text-field 
                            v-model="tel" 
                            dense 
                            outlined 
                            hide-details="auto"                            
                          />
                      </v-col>
                    </v-row>
                  </v-col>
                  <v-col cols="10">
                    <v-row no-gutters><v-col cols="12" align="center" class="search top2">Remark :</v-col></v-row>
                      <v-row no-gutters>
                        <v-col cols="12" align="center" class="search top2 pa-1">
                          <v-text-field 
                            v-model="remark" 
                            dense 
                            outlined 
                            hide-details="auto"                            
                          />
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col class="pt-1">
                    <!-- class="doubleListBox01" -->
                    <DxDataGrid
                      height="250"
                      id="gridMain"
                      :ref="gridMainRef"
                      :data-source="gridMainList" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="false"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                    >
                      <DxPaging :enabled="false" />
                      <DxPager :visible="false" />
                      <DxScrolling mode="virtual"/>
                      <DxColumn data-field="resSeq" caption="Seq." width="3%" data-type="number" format="#,###" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="shipNo" caption="Ship No" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="block" caption="Block" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="cutGrp" width="5%" alignment="center" :allow-editing="false" header-cell-template="Cutting" />
                      <template #Cutting>
                        <div>Cutting<br>Group</div>
                      </template>
                      <DxColumn data-field="keySer" width="5%" alignment="center" :allow-editing="false" header-cell-template="Ser" />
                      <template #Ser>
                        <div>Ser<br>No</div>
                      </template>
                      <DxColumn data-field="newLotGbn" width="5%" alignment="center" :allow-editing="false" header-cell-template="Assy" />
                      <template #Assy>
                        <div>Assy<br>Lot</div>
                      </template>
                      <DxColumn data-field="stlLot" width="5%" alignment="center" :allow-editing="false" header-cell-template="Steel" />
                      <template #Steel>
                        <div>Steel<br>Lot</div>
                      </template>
                      <DxColumn data-field="dwgNo" width="5%" alignment="center" :allow-editing="false" header-cell-template="Drawing" />
                      <template #Drawing>
                        <div>Drawing<br>Page</div>
                      </template>
                      <DxColumn data-field="nextAssy" caption="Next Assy" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="assyNo" caption="Assy" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="pcsNo" caption="PCS" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="pcsType" caption="Specification" width="20%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="assyStg" width="5%" alignment="center" :allow-editing="false" header-cell-template="AssyStage" />
                      <template #AssyStage>
                        <div>Assy<br>Stage</div>
                      </template>
                      <DxColumn data-field="pcsQty" width="5%" alignment="center" :allow-editing="false" header-cell-template="Req" />
                      <template #Req>
                        <div>Req.<br>Qty</div>
                      </template>
                      <DxColumn data-field="pcsWeight" width="5%" alignment="center" :allow-editing="false" header-cell-template="PCS" />
                      <template #PCS>
                        <div>PCS<br>Weight</div>
                      </template>
                      <DxColumn data-field="pcsArea" caption="Area" width="5%" alignment="center" :allow-editing="false" />
                      <DxSummary :calculate-custom-summary="calcCustomSummary01">
                          <DxTotalItem column="shipNo" summary-type="count" display-format="SUM" />
                          <DxTotalItem column="pcsQty" summary-type="sum" :customize-text="totalFormat" />
                          <DxTotalItem show-in-column="pcsWeight" summary-type="custom" name="sumWeight" />
                      </DxSummary>

                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

            <v-row no-gutters>
              <v-col cols="12" class="pt-2">
                <v-row no-gutters>
                  <v-col class="">
                    <i-card-top
                      class="d-md-flex"
                      outlined
                      :useBtnList="useBtnList3"                        
                      @btnAdd="btnAdd()"
                    >
                      <template v-slot:body>
                        <v-row no-gutters class="center pa-2">
                          <i-label :label="' Ship No :'" />
                          <v-col cols="2">
                            <v-autocomplete
                              v-model=" shipNo"
                              :items="shipNoList"
                              return-object
                              item-value="code"
                              item-text="codeName"
                              single-line
                              outlined
                              dense
                              height="32"
                              @change="getBlockList"
                            />
                          </v-col>
                          <i-label :label="' Block :'" class="pl-2"/>
                          <v-col cols="2">
                            <v-autocomplete
                              v-model="block"
                              :items="blockList"
                              return-object
                              item-value="block"
                              item-text="block"
                              outlined
                              dense
                              height="32"
                              @change="getMain2()"
                              />
                          </v-col>
                        </v-row>
                      </template>
                    </i-card-top>
                  </v-col>
                </v-row>

                <v-row no-gutters>
                  <v-col class="pt-1">
                    <DxDataGrid
                      class="doubleListBox04"
                      id="gridMain2"
                      :ref="gridMain2Ref"
                      :data-source="gridMainList2" 
                      :remote-operations="false" 
                      :hover-state-enabled="true"
                      :allow-column-resizing="true" 
                      :allow-column-reordering="true"
                      :row-alternation-enabled="true" 
                      :show-borders="true" 
                      :width="grid.width"
                      :show-row-lines="true" 
                      key-expr="id" 
                      :focused-row-enabled="false"
                      :column-hiding-enabled="false" 
                      :sorting="{ mode: 'none' }"
                      @cellPrepared="cellPrepared"
                      @selection-changed="onSelectionChanged"
                      @editingStart="editingStart"
                    >
                      <DxPaging :enabled="false"/>
                      <DxPager :visible="false" />
                      <DxEditing :use-icons="true" mode="cell" />

                      <DxColumn data-field="cutGrp" width="5%" alignment="center" :allow-editing="false" header-cell-template="Cutting" />
                      <template #Cutting>
                        <div>Cutting<br>Group</div>
                      </template>
                      <DxColumn data-field="keySer" width="5%" alignment="center" :allow-editing="false" header-cell-template="Ser" />
                      <template #Ser>
                        <div>Ser<br>No</div>
                      </template>
                      <DxColumn data-field="newLotGbn" width="5%" alignment="center" :allow-editing="false" header-cell-template="AssyLot" />
                      <template #AssyLot>
                        <div>Assy<br>Lot</div>
                      </template>
                      <DxColumn data-field="stlLot" width="5%" alignment="center" :allow-editing="false" header-cell-template="Steel" />
                      <template #Steel>
                        <div>Steel<br>Lot</div>
                      </template>
                      <DxColumn data-field="dwgNo" width="5%" alignment="center" :allow-editing="false" header-cell-template="Drawing" />
                      <template #Drawing>
                        <div>Drawing<br>Page</div>
                      </template>
                      <DxColumn data-field="nextAssy" caption="Next Assy" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="assyNo" caption="Assy" width="7%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="pcsNo" caption="PCS" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="pcsType" caption="Specification" width="20%" alignment="left" :allow-editing="false" />
                      <DxColumn data-field="assyStg" width="5%" alignment="center" :allow-editing="false" header-cell-template="AssyStage" />
                      <template #AssyStage>
                        <div>Assy<br>Stage</div>
                      </template>
                      <DxColumn data-field="remQty" width="5%" alignment="right" :allow-editing="false" header-cell-template="PCS" />
                      <template #PCS>
                        <div>PCS<br>Qty</div>
                      </template>
                      <DxColumn data-field="pcsWeight" width="5%" alignment="right" :allow-editing="false" header-cell-template="PCSWeight" />
                      <template #PCSWeight>
                        <div>PCS<br>Weight</div>
                      </template>
                      <DxColumn data-field="pcsArea" caption="Area" width="5%" alignment="center" :allow-editing="false" />
                      <DxColumn data-field="requestQty" width="5%" alignment="right" header-cell-template="Request" />
                      <template #Request>
                        <div>Request<br>Qty</div>
                      </template>

                      <DxSummary :calculate-custom-summary="calcCustomSummary">
                          <DxTotalItem column="stlLot" summary-type="count" display-format="SUM" />
                          <DxTotalItem column="remQty" summary-type="sum" :customize-text="totalFormat" />
                          <DxTotalItem show-in-column="pcsWeight" summary-type="custom" name="sumWeight" />
                          <DxTotalItem column="requestQty" summary-type="sum" :customize-text="totalFormat" />
                      </DxSummary>

                    </DxDataGrid>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>

          </template>
        </i-card-vertical>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import baseview from '@/components/base/baseview.vue'
import BaseDataGrid from '@/components/base/BaseDataGrid.vue'
import DxDateBox from 'devextreme-vue/date-box'
import { getCarList , getDriverList, getMovLocList, getResGrpList } from '@/api/view/hip/common/common.js'
import { getSAResNoList, getListConfirmed , epmsa012Head , epmsa012Detail , getShipNoList , epmsa010BlockList ,
    epmsa010List2 , epmsa010Save, epmsa010Add , epmsa010Delete , epmsa012xls, epmsa010ResGrp, epmsa010MovLoc} from '@/api/view/hip/A/epmsa010'
import { reportView } from '@/api/view/hip/common/common'
import notify from 'devextreme/ui/notify'
import dayjs from 'dayjs';
import { getNumComma, toNum } from '@/utils/common.js'
import { getDateFormat, getFirstDate, getLastDate } from '@/utils/common.js'


export default {
  name: 'epmsa010',
  mixins: [baseview, BaseDataGrid],
  components: {
    DxDateBox,
  },
  data() {
    return {
      makerCd: this.$store.state.user.makerCd,
      userId: this.$store.state.user.userId,
      menuTitle: this.$route.meta.title,
      gridMainRef: 'gridMainRef',
      gridMain2Ref: 'gridMain2Ref',

      useBtnListKey: 0,
      unUseBtnList: [],
      useBtnList: ['btnSave','btnPrint', 'btnSaveAsExcel','btnDelete'],
      useBtnListTemp: ['btnSave','btnPrint', 'btnSaveAsExcel','btnDelete'],
      useBtnList3 : [],
      customBtnList: [
        { id: 'btnSaveAsExcel', text: 'Save as Excel', icon: 'excel' }
      ],
      setBtnColor: 'setBtnColor',

      resNo: '',
      resNoList: [],
      resNoCF: '',
      resNoListCF: [],

      carNo: '',
      carNoList: [],

      movLoc: '',
      movLocList: [],

      resGrp: '',
      resGrpList: [],

      perNo: '',
      perNoList: [],
      shipNo: '',
      shipNoList: [],
      block: '',
      blockList: [],

      plnCarryOutDte: '',
      remark: '',

      tel: '',
      prtDetail : false,
      alreadyCF : false,
      gridMainList: [],
      gridMainList2: [],

      editingGbn: false,
      saveResNo: '',
      stDte: null,
      edDte: null
    }
  },
  computed: {
    gridInstance() {
      return this.GetDataGrid(this.gridMainRef)
    },
    gridInstance2() {
      return this.GetDataGrid(this.gridMain2Ref)
    },
  },
  mounted() {
    this.init()
  },
  methods: {
    totalFormat(e) {
            const result = getNumComma(Number(e.value.toFixed(2)), 2)
            return result
    },
    getNumComma(val) {
      return getNumComma(Number(val))
    },
    getStrFormat(date) {
      return getDateFormat(date)
    },
    checkAlreadyCF(e){
        if(e)
        {         
          this.getListConfirmed()
        }          
        else
        {
          //useBtnList: ['btnSave','btnPrint', 'btnSaveAsExcel','btnDelete'],
          this.getResNoList()
        } 
        this.gridMainList = []
        this.setBtnList()         
    },   
    setBtnList() {
      let btnTemp = this.$_.cloneDeep(this.useBtnListTemp)
      
      if(this.alreadyCF) {
        //this.unUseBtnList.push('btnSave')
        //this.unUseBtnList.push('btnDelete')
        this.useBtnList3 = []
        btnTemp = this.$_.filter(btnTemp, function(btnTemp) {
          return btnTemp !== 'btnSave' && btnTemp !== 'btnDelete'
        })
      } 
      
      this.useBtnList = btnTemp
      this.useBtnListKey++      
    },
    calcCustomSummary01(options) {      
     
     if (options.name === 'sumWeight') {
       if (options.summaryProcess === 'start') {
         options.totalValue = 0;
       }   

       if (options.summaryProcess === 'calculate' ) {
         options.totalValue += Number(options.value.pcsQty)*Number(options.value.pcsWeight);
       }

       if (options.summaryProcess === 'finalize' ) {
         options.totalValue = getNumComma(options.totalValue.toFixed(1));
       }
     }
   
 },
     calcCustomSummary(options) {      
     
        if (options.name === 'sumWeight') {
          if (options.summaryProcess === 'start') {
            options.totalValue = 0;
          }   

          if (options.summaryProcess === 'calculate' ) {
            options.totalValue += Number(options.value.remQty)*Number(options.value.pcsWeight);
          }

          if (options.summaryProcess === 'finalize' ) {
            options.totalValue = getNumComma(options.totalValue.toFixed(1));
          }
        }
      
    },
    async init() {
      this.unUseBtnList = []
      this.useBtnList = []
      this.gridInstance.option('defaultPaging', false)
      this.gridInstance2.option('defaultPaging', false)
      this.stDte = getFirstDate('m')
      this.edDte = getLastDate('m')
      this.getResNoList()
      this.getListConfirmed()
      this.getList()
      this.setBtnList()
    },
    async getResNoList(){
      this.resNoList = []
      let param = {
        makerCd: this.makerCd
      }
      await getSAResNoList(param).then(res => {
        this.resNoList.push({code: '' , codeName: 'New'})
        res.list.forEach(e => {
          e.code = e.resNo
          e.codeName = e.resNo
          this.resNoList.push(e)
          if(e.code == this.saveResNo){
            this.resNo = e
          }
        });
      })
    },
    async getListConfirmed(){
      this.resNoList = []
      let param = {
        makerCd: this.makerCd,
        fromDt: this.stDte.replace(/-/g, ""),
        toDt: this.edDte.replace(/-/g, "")
      }      

      await getListConfirmed(param).then(res => {       
        console.log(res)
        res.list.forEach(e => {          
          e.code = e.resNo
          e.codeName = e.resNo
          this.resNoListCF.push(e)          
        });
      })      
    },
    async getList(){
      try {
        this.openLoading('searching')
        let param = {
          makerCd: this.makerCd
        }
        await getCarList(param).then(res => {
          this.carNoList.push({code: '' , codeName: ''})
          res.list.forEach(e => {
            e.code = e.carNo
            e.codeName = e.carLicense
            this.carNoList.push(e)
          });
          this.carNo = this.resNoList[0]
        })

        await getDriverList(param).then(res => {
          this.perNoList.push({code: '' , codeName: ''})
          res.list.forEach(e => {
            e.code = e.perNo
            e.codeName = !e.perEnm ? '' : e.perEnm
            this.perNoList.push(e)
          });
          this.perNo = this.perNoList[0]
        })

        await epmsa010MovLoc(param).then(res => {
          this.movLocList.push({code: '' , codeName: ''})
          res.list.forEach(e => {
            e.code = e.movLoc
            e.codeName = !e.movLocNm ? '' : e.movLocNm
            this.movLocList.push(e)
          });
          this.movLoc = this.movLocList[0]
        })

        await getShipNoList(param).then(res => {
          this.shipNoList.push({code: '' , codeName: 'Select'})
          res.list.forEach(e => {
            e.code = e.shipNo
            e.codeName = !e.shipNo ? '' : e.shipNo
            this.shipNoList.push(e)
          });
          this.shipNo = this.shipNoList[0] 
        })
      } finally {
        this.endLoading()
      }
    },
    btnRetrieve() {
      this.epms90a1List = []
      this.getMain()
    },
    async getMain(saveResNo){
      try {
        this.openLoading('searching')
        let data = ''
        if(saveResNo){
          data = saveResNo
        } else {
          data = this.alreadyCF ? this.resNoCF.code : this.resNo.code
        }
        let param = {
          resNo: data
        }

        if(!this.alreadyCF && data && data != 'New' )
        {
          this.useBtnList3 = ['btnAdd']         
        }else{
          this.useBtnList3 = []         
        }

        await epmsa012Head(param).then(res => {
          if(res.list.length > 0){
            this.plnCarryOutDte = res.list[0].plnCarryOutDte
            this.remark = !res.list[0].remark ? '' : res.list[0].remark
            this.carNoList.forEach(e => {
              if(res.list[0].carNo == e.code){
                this.carNo = {code: res.list[0].carNo , codeName: e.codeName}
              }
            });
            console.log('res list :' ,res.list)
            this.movLocList.forEach(e => {
              if(res.list[0].movLoc == e.code){
                this.movLoc = {code: res.list[0].movLoc , codeName: e.codeName}
              }
            });

            this.tel = !res.list[0].tel ? '' : res.list[0].tel 
            //this.showCfmLabel = res.list[0].confirmYn === 'Y' ? true : false
          }
        })
        await epmsa012Detail(param).then(res => {
          let cnt = 0
          res.list.forEach(e => {
            e.id = cnt++
          });
          this.gridMainList = res.list
        })
      } finally {
        this.gridInstance.clearSelection()
        this.endLoading()
      }
    },
    async getBlockList(){
      let param = {
        shipNo: this.shipNo.code
      }
      this.openLoading('searching')
      await epmsa010BlockList(param).then(res => {
        this.blockList = []
        this.blockList.push({block: ''})
        res.list.forEach(e => {
          this.blockList.push(e)
        });
        this.block= this.blockList[0]
      }).finally(() => {
        this.endLoading()
      })
    },
    async getMain2(){
      try {
        this.openLoading('searching')
        this.gridMainList2 = []
        let param = {
          makerCd: this.makerCd,
          shipNo: this.shipNo.code,
          block: !this.block.block ? '' : this.block.block
        }       
        await epmsa010List2(param).then(res => {
          if(res.list.length > 0){
            let cnt = 0
            res.list.forEach(e => {
              e.id = cnt++
              e.requestQty = '0'
            })
            this.gridMainList2 = res.list
          }
        })
      } finally {
        this.gridInstance2.clearSelection()
        this.endLoading()
      }
    },
    async btnSave(){
      if(!this.plnCarryOutDte){
        this.vToastify(this.$t("Select Carry Out Date."), 'warn')
        return
      }
      if(!this.carNo.code){
        this.vToastify(this.$t("Input Car No."), 'warn')
        return
      }
      if(!this.perNo.code){
        this.perNo.code = '0000'
      }

      if(!this.movLoc.code || this.movLoc.code =='') {
        this.vToastify(this.$t("Select moving location please."), 'warn')
        return
      }

      await this.gridInstance2.saveEditData()
      var selectedMainRows = await this.gridInstance2.getSelectedRowsData()
      let cnt = 0
      let param = []
      console.log(selectedMainRows)
      if(this.gridMainList2.length > 0){
        for(var row of selectedMainRows){
          row.plnCarryOutDte = dayjs(this.plnCarryOutDte).format('YYYY-MM-DD')
          row.carNo = this.carNo.code
          row.remark = this.remark
          row.userId = this.userId
          row.makerCd = this.makerCd
          row.mAct = !row.mAct ? '' : row.mAct
          row.bomSerno = !row.bomSerno ? '' : row.bomSerno
          row.movLoc = this.movLoc.code
          row.recvEmp = this.perNo.codeName
          row.tel     = this.tel
          row.div = 'T30M_1040'

          if(Number(row.requestQty) > Number(row.remQty)){
            this.vToastify(this.$t("Over Request."), 'warn')
            console.log('request : ' + row.requestQty + '   remain : ' + row.remQty)
            return
          } else if(Number(row.requestQty) > 0){
            cnt++
            param.push(row)
          }
        }
      }

      if(cnt === 0){
        this.vToastify(this.$t("Select data."), 'warn')
        return
      }
      this.vToastifyPrompt(
        this.$t('Do you wan to save the  data?'),
        'info',
          current => {
            this.openLoading('searching')
            epmsa010Save(selectedMainRows)
              .then(res => {
                console.log(res.body) ;
                const result = res.body.substring(0,1)
                this.saveResNo= res.body.substring(1)
                if(result == 'Y'){
                  notify(this.$t('Saving is completed.'), 'success', 3000)
                } else {
                  this.vToastify(this.$t(res.body), 'warn')
                }
              })
              .catch(error => {
                console.log(res.body) ;
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.plnCarryOutDte = ''
                this.carNo = '',
                this.movLoc = '',
                this.tel = ''
                this.gridInstance2.clearSelection()
                this.getResNoList()
                this.getMain(this.saveResNo)
                this.getMain2()
                this.endLoading()
              })
          },
        null,
        true
      )
    },

    async btnAdd(){
      if(!this.resNo.code){
        this.vToastify(this.$t("Request Number is null."), 'warn')
        return
      }

      if(!this.plnCarryOutDte){
        this.vToastify(this.$t("Carry Out Date is null.."), 'warn')
        return
      }
     
      if(!this.perNo.code){
        this.perNo.code = '0000'
      }

      if(!this.movLoc.code || this.movLoc.code =='') {
        this.vToastify(this.$t("Moving location is null."), 'warn')
        return
      }

      await this.gridInstance2.saveEditData()
      var selectedMainRows = await this.gridInstance2.getSelectedRowsData()
      let cnt = 0
      let param = []
      console.log(selectedMainRows)
      if(this.gridMainList2.length > 0){
        for(var row of selectedMainRows){
          row.resNo = this.resNo.code
          row.plnCarryOutDte = dayjs(this.plnCarryOutDte).format('YYYY-MM-DD')
          row.carNo = this.carNo.code
          row.remark = this.remark
          row.userId = this.userId
          row.makerCd = this.makerCd
          row.mAct = !row.mAct ? '' : row.mAct
          row.bomSerno = !row.bomSerno ? '' : row.bomSerno
          row.movLoc = this.movLoc.code
          row.recvEmp = this.perNo.codeName
          row.tel     = this.tel
          row.div = 'T30M_1040'

          if(Number(row.requestQty) > Number(row.remQty)){
            this.vToastify(this.$t("Over Request."), 'warn')            
            return
          } else if(Number(row.requestQty) > 0){
            cnt++
            param.push(row)
          }
        }
      }

      if(cnt === 0){
        this.vToastify(this.$t("Select data."), 'warn')
        return
      }
      this.vToastifyPrompt(
        this.$t('Do you wan to save the data?'),
        'info',
          current => {
            this.openLoading('searching')
            epmsa010Add(selectedMainRows)
              .then(res => {
                console.log(res.body) ;
                const result = res.body.substring(0,1)               
                if(result == 'Y'){
                  notify(this.$t('Added to request successfully.'), 'success', 3000)
                } else {
                  this.vToastify(this.$t(res.body), 'warn')
                }
              })
              .catch(error => {
                console.log(res.body) ;
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {                
                this.gridInstance2.clearSelection()
                this.getResNoList()
                this.getMain()
                this.getMain2()
                this.endLoading()
              })
          },
        null,
        true
      )
    },

    btnPrint(){
      let lcResNo = this.alreadyCF ? this.resNoCF.code : this.resNo.code

      if(!lcResNo){
        this.vToastify(this.$t("Select Request No."), 'warn')
        return
      }
      const param = {
        fileName: this.prtDetail == true ? 'epmsa010.jrxml': 'epmsa010Sum.jrxml',
        as_res_no: lcResNo,
        as_maker_cd: this.makerCd
      }
      this.openLoading('searching')
      reportView(param)
      .finally(() => {
        this.endLoading()
      })
    },
    async btnDelete(){
      await this.gridInstance.saveEditData()
      var selectedMainRows = await this.gridInstance.getSelectedRowsData()

      if(!selectedMainRows.length){
        this.vToastify(this.$t("Data is not selected for delete."), 'warn')
        return
      }

      for(var row of selectedMainRows){
        row.div = 'T30M_1040'
        row.userId = this.userId
        // row.appNo = !row.appNo ? '' : row.appNo
      }
      this.vToastifyPrompt(
        this.$t('Do you want to delete?'),
        'info',
          current => {
            this.openLoading('searching')
            epmsa010Delete(selectedMainRows)
              .then(res => {
                const result = res.body
                if(result == 'Y'){
                  notify(this.$t('Delete is complete.'), 'success', 3000)
                } else {
                  this.vToastify(this.$t(result), 'warn')
                }
              })
              .catch(error => {
                this.vToastify(error, 'warn')
                this.endLoading()
              })
              .finally(() => {
                this.plnCarryOutDte = ''
                this.carNo = ''
                this.gridInstance.clearSelection()
                this.getResNoList()
                this.getMain()
                this.getMain2()
                this.endLoading()
              })
          },
        null,
        true
      )
    },
    btnSaveAsExcel(){

      let lcResNo = this.alreadyCF ? this.resNoCF.code : this.resNo.code

      if(!lcResNo){
        this.vToastify(this.$t("Select Request No."), 'warn')
        return
      }
      const param = {
        resNo: lcResNo,
      }
      epmsa012xls(param)
    },
    async onSelectionChanged(e){
      const selRows = await e.component.getSelectedRowKeys()

      for(let i = 0; i < e.component.totalCount(); i++) {
        const find = this.$_.find(selRows, row => {
          return row === i
        })
        let remQty = this.gridMainList2[i].remQty 
        let reqQty = e.component.cellValue(i, 'requestQty')
        
        if((find || find == '0') && reqQty == '0') {       
          e.component.getCellElement(i, 'requestQty').classList.remove('cancel-editable-cell')
          this.gridMainList2[i].requestQty = remQty //'1'
        } else {
          e.component.getCellElement(i, 'requestQty').classList.add('cancel-editable-cell')
          //this.gridMainList2[i].requestQty = '0'
        }
      }
    },
    test(e){
    },
    async editingStart(e){
      if(e.column.dataField === 'requestQty' && e.data.requestQty == '0' ){
        e.cancel = true
      } else {
        e.cancel = false
      }
    },
    async cellPrepared(e){
      if(e.rowType === 'header'){

      } else {
        if(e.column.dataField == 'requestQty'){
          e.cellElement.classList.add('cancel-editable-cell')
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.search{
  font-weight: bold;
  color: black;
}
.top{
  background-color: #C0E0FF;
  border-left: 1px solid #B4BAC6;
}
.top2{
  background-color: #C0E0FF;
  border-top: 1px solid #B4BAC6;
}
.subText {
  border: 1px solid #B4BAC6;
  color: black;
}
.subTitle2 {
  font-weight: bold;
  color: red;
}
$redBtn: #FF0000;
.setBtnColor::v-deep {
  [role=btnDelete]{
    .v-btn__content {
      div {
        color: #{$redBtn} !important;
      }

      i {
        color: #{$redBtn} !important;
      }
    }
  }
}
</style>
